import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Tab, Tabs } from "@mui/material";
import { withLocalizer } from "utilities/withLocalizer";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import TermConditionEditor from "./termConditionEditor";
import { updateCustomQuote } from "services/customQuote/customQuote.service";
import commonUtilities from "utilities/common";
import { CONFIGURATION } from "utilities/configuration";

import "../../customize.scss";


export class CustomizeQuoteStepFive extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabIndex: 0
        };
    }

    handleTabChange = (event, newIndex) => {

        commonUtilities.scrollToSection("term-conditions-editor-container", 80);

        this.setState({ tabIndex: newIndex });
        
        let { customQuote } = this.props;
        if(customQuote?.data?.termsAndConditions && customQuote?.data?.termsAndConditions.length > 0) {

            this.props.dispatch(updateCustomQuote({
                ...customQuote?.data,
                termsAndConditions: customQuote?.data?.termsAndConditions?.map((term, index) => {
                    if(index === newIndex) {
                        return { ...term, isReviewed: true };
                    }
                    else {
                        return term;
                    }
                })
            }));
        }
        if(this.props.events.onTermTabChange) {
            this.props.events.onTermTabChange(newIndex);
        }
    };

    onChangeTerms = (value, isChanged, indexTab) => {
        let { customQuote } = this.props;
        this.props.dispatch(updateCustomQuote({
            ...customQuote?.data,
            termsAndConditions: customQuote?.data?.termsAndConditions?.map((term, index) => {
                if(term && indexTab === index) {
                    return { ...term, description: value, isChanged: isChanged };
                }
                else {
                    return term ;
                }
            })
        }));
    };

    a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            "aria-controls": `simple-tabpanel-${index}`
        };
    }

    render() {
        const { data, customQuote, events, errors } = this.props;
        const { currentStep } = data;
        if (currentStep !== 5) {
            return null;
        }

        const termsAndConditions = customQuote?.data?.termsAndConditions || [];

        const { tabIndex, value } = this.state;
        const tabCount = termsAndConditions?.length || 0;
        
        const isOutlineIcon = CONFIGURATION.CHECK_CIRCLE_ROUNDED_ICON_IS_OUTLINED;

        return (
            <>
                {termsAndConditions && termsAndConditions.length > 0 ? 
                    <div className="step-editor">
                        <div className="step-heading">
                            <h4>{ this.props.localize("qma-custom-quote-step-5-heading") }</h4>
                            <div>
                                { this.props.localize("qma-custom-quote-step-5-intro") }
                            </div>
                        </div>
                        <div className="custom-quote-editor-container margin-top-2x" id="term-conditions-editor-container">
                            <Tabs 
                                value={tabIndex} 
                                onChange={this.handleTabChange} 
                                aria-label="terms tabs" 
                                className="term-tabs"
                                variant="standard" //	'fullWidth' | 'scrollable' | 'standard'
                                // scrollButtons={"auto"}
                            >
                                { termsAndConditions.map((termCondition, index) => 
                                    <Tab 
                                        // wrapped={false}
                                        key={`tab-${index}`}
                                        icon={isOutlineIcon ? <CheckCircleOutlineRoundedIcon className={"term-review-icon" + (termCondition.isReviewed ? " reviewed": "")} /> : <CheckCircleRoundedIcon className={"term-review-icon" + (termCondition.isReviewed ? " reviewed": "")} />} 
                                        iconPosition="start" 
                                        label={termCondition.title} 
                                        {...this.a11yProps(index)} />
                                )}
                            </Tabs>
                            { termsAndConditions.map((termCondition, index) => 
                                <div
                                    className="custom-quote-editor-panel-wrapper"
                                    key={`tabpanel-${index}`}
                                    role="tabpanel"
                                    hidden={tabIndex !== index}
                                    id={`simple-tabpanel-${index}`}
                                    aria-labelledby={`simple-tab-${index}`}
                                >
                                    <div className="custom-quote-editor-panel">
                                        <div className="editor-tip">
                                            { this.props.localize("qma-custom-quote-editor-terms-textbox-tip") }
                                        </div>
                                        <div className="quote-information-editor term-condition">
                                            <TermConditionEditor
                                                data={{ description: termCondition.description, originalText: termCondition.originalText, index: index }}
                                                events={{ onChangeTerms: this.onChangeTerms }}
                                            />
                                        </div>
                                        <div className="text-align-right">
                                            {(tabIndex + 1) < tabCount ?
                                                <Button className="btn-blue-white btn-white-blue-sm" data-testid="info-btn" variant="contained" onClick={(event) => {
                                                    this.handleTabChange(event, tabIndex + 1);
                                                }}>
                                                    { this.props.localize("qma-navigation-next") }
                                                </Button>
                                                : null
                                            }
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    : null
                }
            </>
        );
    }
    
}

const mapStateToProps = (state) => ({
    customQuote: state.customQuote
});

export default connect(mapStateToProps)(withLocalizer(CustomizeQuoteStepFive));
